import React, { ReactElement } from "react"

export default function NotFound404Page(): ReactElement | null {
  return <div>Not Found: 404</div>
}
